class FaqDrawer extends HTMLElement {
  connectedCallback() {
    this.isOpen = false;
    this.drawerId = this.dataset.drawerId;
    this.overlay = this.querySelector('.page-overlay-faq');
    this.closeBtn = this.querySelector('.wt-faq__drawer__close');
    this.bodyClass = `faq-drawer-open--${this.drawerId}`;

    this.overlay.addEventListener('click', () => this.close());
    this.closeBtn.addEventListener('click', (e) => { e.preventDefault(); this.close(); });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) this.close();
    });

    const trigger = document.querySelector(`[data-faq-drawer-trigger="${this.drawerId}"]`);
    if (trigger) {
      trigger.addEventListener('click', (e) => { e.preventDefault(); this.open(); });
    }
  }

  open() {
    this.isOpen = true;
    document.body.classList.add(this.bodyClass);
  }

  close() {
    this.isOpen = false;
    document.body.classList.remove(this.bodyClass);
  }
}

customElements.define('faq-drawer', FaqDrawer);